// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2YdcB","ranges":"BmiRanges_ranges__1KEiZ"};